import { Navigate } from 'react-router-dom';

import { COIDebug } from '@/pages/overview/coi-debug/COIDebug';
import { CompanyOverview } from '@/pages/overview/company-overview/CompanyOverview';
import { ContractClauses } from '@/pages/overview/contract-clauses/ContractClauses';
import { ContractClauses as ContractClausesOld } from '@/pages/overview/contract-clauses-old/ContractClausesOld';
import { DataRoom } from '@/pages/overview/dataroom/DataRoom';
import { FinancingRights } from '@/pages/overview/financing-rights/FinancingRights';
import { MissingDocuments } from '@/pages/overview/missing-documents/MissingDocuments';
import { MissingDocumentsIdentify } from '@/pages/overview/missing-documents-identify/MissingDocumentsIdentify';
import { MissingSignaturesDebug } from '@/pages/overview/missing-signatures-debug/MissingSignaturesDebug';
import { PersonnelReport } from '@/pages/overview/personnel-report/PersonnelReport';
import RedlineClustering from '@/pages/overview/redline/clustering/RedlineClustering';
import RedlineDiffing from '@/pages/overview/redline/diffing/RedlineDiffing';
import { RedlineListing } from '@/pages/overview/redline/listing/RedlineListing';
import Redline from '@/pages/overview/redline/Redline';
import { VetoDebug } from '@/pages/overview/veto-debug/VetoDebug';
import { ToolPage } from '@/pages/tools/ToolPage';

/**
 * Redline nested routes - used within the redline feature
 */
export const REDLINE_ROUTES = [
  {
    index: true,
    element: <RedlineListing />,
  },
  {
    path: ':redlineName/clustering',
    element: <RedlineClustering />,
  },
  {
    path: ':redlineName/diff',
    element: <RedlineDiffing />,
  },
];

/**
 * Client matter routes - shared between both URL patterns
 * These routes work for both /:clientMatterId/* and /:clientNumber/:matterNumber/*
 */
export const CLIENT_MATTER_ROUTES = [
  {
    index: true,
    element: <Navigate to="dataroom" replace />,
  },
  {
    path: 'tool-page',
    element: <ToolPage />,
  },
  {
    path: 'dataroom',
    element: <DataRoom />,
  },
  {
    path: 'missing-documents',
    element: <MissingDocuments />,
  },
  {
    path: 'missing-documents-identify',
    element: <MissingDocumentsIdentify />,
  },
  {
    path: 'missing-signatures-debug',
    element: <MissingSignaturesDebug />,
  },
  {
    path: 'coi-debug',
    element: <COIDebug />,
  },
  {
    path: 'veto-debug',
    element: <VetoDebug />,
  },
  {
    path: 'financing-rights',
    element: <FinancingRights />,
  },
  {
    path: 'personnel-report',
    element: <PersonnelReport />,
  },
  {
    path: 'company-overview',
    element: <CompanyOverview />,
  },
  {
    path: 'document-analysis',
    element: <ContractClauses />,
  },
  {
    path: 'contract-clauses-old',
    element: <ContractClausesOld />,
  },
  {
    path: 'redline',
    element: <Redline />,
    children: REDLINE_ROUTES,
  },
];
